import React, { useEffect, useRef, useState } from "react";
import styles from "./comp_css/chapter_10.module.css";
import Head from "next/head";
import MembershipModal from "../../../components/Modal/MembershipModal";
import { useRouter } from "next/router";
import { Link } from "@mui/material";
import BlockData from "../../../central-doctraine-json/chapter10.json";
import Common_html from "./Common_html";

export default function Chapter_8() {

  // const corosalref = useRef()

  // useEffect(() => {
  //   if (corosalref.current) {
  //     corosalref.current.scrollIntoView({
  //       behavior: "smooth",
  //       block: "nearest",
  //       inline: "start"
  //     })
  //   }
  //   console.log("CurrentImageComponent", corosalref.current);
  // }, [corosalref.current])

  const router = useRouter()
    const location = useRouter();
    const { pathname } = location;

    const [membershipOpen, setMembershipOpen] = useState(false);
    const memberfunc = () => {
      setMembershipOpen(true);
  };

  return (
    <>

      <Head>
        <title>Jungian Psychology | School of Our Divine Infinite Being</title>
        <meta name="viewport" content="width=device-width, initial-scale=1.0"></meta>
        <meta name="keywords" content="Divine Infinite Being, Central Doctrine, Chapter-X"></meta>
        <meta property="og:title" content="Jungian Psychology | School of Our Divine Infinite Being"></meta>
        <meta property="og:type" content="website"></meta>
        <meta property="og:image" content="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/meta_data/Chapter10_OG_image_10_04-10-2023_v1_new.webp"></meta>
        <meta property="og:image:alt" content="Image illustrating a symbolic representation of Jungian psychology within the framework of Divine Infinite Being. The artwork features a central mandala with intricate patterns, surrounded by archetypal symbols such as the shadow, anima, and animus. A backdrop of cosmic imagery suggests a deep connection between the psychological archetypes and the divine, emphasizing the integration of the self and spiritual dimensions."></meta>
        <meta property="og:description" content="Jungian archetypes are defined as universal, primal symbols and images that derive from the collective unconscious."></meta>

        <meta property="og:image:width" content="1200"></meta>
        <meta property="og:image:height" content="627"></meta>
        <meta property="og:url" content="https://www.divineinfinitebeing.com/central-doctrine?chapter=9"></meta>

        <meta name="twitter:card" content="summary_large_image"></meta>
        <meta property="twitter:image" content="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/meta_data/Chapter10_OG_image_10_04-10-2023_v1_new.webp"></meta>
        <meta property="twitter:image:alt" content="Image illustrating a symbolic representation of Jungian psychology within the framework of Divine Infinite Being. The artwork features a central mandala with intricate patterns, surrounded by archetypal symbols such as the shadow, anima, and animus. A backdrop of cosmic imagery suggests a deep connection between the psychological archetypes and the divine, emphasizing the integration of the self and spiritual dimensions."></meta>
        <meta name="twitter:url" content="https://www.divineinfinitebeing.com/central-doctrine?chapter=9"></meta>
        <meta name="twitter:title" content="Jungian Psychology | School of Our Divine Infinite Being"></meta>
        <meta name="twitter:description" content="Jungian archetypes are defined as universal, primal symbols and images that derive from the collective unconscious."></meta>
         <link rel="canonical" href="https://www.divineinfinitebeing.com/central-doctrine?chapter=10" />
      </Head>


       <Common_html BlockData={BlockData} />
      <MembershipModal membershipOpen={membershipOpen} setMembershipOpen={setMembershipOpen}/>
    </>
  );
}
